import { usePDPContext } from '../[locale]/product/_contexts/PDPProvider';

/**
 * Temporary hook to mimic the behavior seen during the black friday sitewide period where the old
 * MSRP is used as the strikethrough instead of the actual MSRP to visually inflate the discount amount
 *
 * Only used for the natural cycles BF discount
 */
function useShowOldOPrice() {
  const { appliedDiscountCode } = usePDPContext();
  return appliedDiscountCode === 'gen_3_2025';
}

export default useShowOldOPrice;
